import React, { useState } from 'react';
import css from './UploadFromFB.css';
import PicCardForm from './PicCardForm';
import { Form as FinalForm } from 'react-final-form';
import { useFbInitScript } from '../hooks/useFbInitScript';
import { UPLOAD_TYPE_FB_PIC } from '../helpers';
import { useReloadPage } from '../hooks/useReloadPage';
import { Alert } from '../../../components';

const FormContent = ({ values, onImageUpload, isMultiple, inputProps }) => {
    const [error, setError] = useState(null);
    const [images, setImages] = useState([]);

    const { pic } = values;

    const makeFacebookPhotoURL = id =>
        'https://graph.facebook.com/' + id + '/picture?access_token=' + window.FB.getAccessToken();

    const getAlbumPhotos = albumId =>
        new Promise(res => {
            const collectFbPhotos = ({ data }) => {
                const photosUri = data.map(({ id: photoId }) => makeFacebookPhotoURL(photoId));
                res(photosUri);
            };

            window.FB.api(`${albumId}/photos`, { fields: 'id' }, collectFbPhotos);
        });

    const collectAllPhotos = async ({ data }) => {
        if (!Array.isArray(data)) {
            return setError('No data available.');
        }

        const allPhotos = await Promise.all(data.map(({ id }) => getAlbumPhotos(id)));

        setImages(allPhotos.flat());
    };

    const getAlbums = () => window.FB.api('/me/albums', { fields: 'id' }, collectAllPhotos);

    /** add fbAsyncInitScript and FB sdk script */
    const { error: initError, loading, redirectWarning } = useFbInitScript({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID_CONSUMER,
        loginParams: { scope: 'user_photos,public_profile' },
        strategy: UPLOAD_TYPE_FB_PIC,
        onload: getAlbums,
    });

    useReloadPage({ shouldRedirect: !!redirectWarning });

    return (
        <PicCardForm
            formClassName={css.form}
            pic={pic}
            heading="Facebook"
            error={error || initError}
            loading={loading}
            images={images}
            onBlobRequest={onImageUpload}
            isMultiple={isMultiple}
            inputProps={inputProps}
        >
            {redirectWarning ? (
                <Alert
                    type="info"
                    showAsPlainText
                    description="Du wirst in Kürze weitergeleitet, damit Du auf deine Fotos bei Facebook zugreifen kannst."
                    closeAllowed={false}
                    rootClassName={css.redirectWarning}
                />
            ) : null}
        </PicCardForm>
    );
};

export default props => (
    <FinalForm
        initialValues={{}}
        onSubmit={() => null}
        render={renderProps => <FormContent {...props} {...renderProps} />}
    />
);
